"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadConfig = void 0;
var _slice = require("./slice");
var _api = require("../../../api");
var _adapters = require("./adapters");
var _response = require("../../../utils/response");
var configMock = _interopRequireWildcard(require("../../../config"));
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const fetchBrandId = async () => {
  if (process.env.NODE_ENV === _constants.NODE_ENV.production) {
    const [, configFile] = await (0, _api.fetchConfigFile)();
    return configFile.brandId;
  }

  // using mocked values locally
  return configMock.brandId;
};
const loadConfig = passedBrandId => async dispatch => {
  if (process.env.NODE_ENV === _constants.NODE_ENV.test) {
    // config is populated with mocked values in CI
    dispatch(_slice.configSlice.actions.loadSuccess(configMock));
    return;
  }
  dispatch(_slice.configSlice.actions.loadConfig());
  const brandId = passedBrandId || (await fetchBrandId());
  (0, _api.assignGlobalBrandParam)(_api.apiRequest, brandId);
  dispatch(_slice.configSlice.actions.updateConfig({
    brandId
  }));
  const [error, data] = await (0, _api.fetchConfig)(brandId);
  if (!error && data) {
    const adaptedConfig = (0, _adapters.getAdaptedConfig)(data);
    dispatch(_slice.configSlice.actions.loadSuccess(adaptedConfig));
  } else {
    const errorMessage = (0, _response.getErrorMessage)(error) || (0, _response.getErrorResponseData)(error);
    dispatch(_slice.configSlice.actions.loadFailure(errorMessage));
  }
};
exports.loadConfig = loadConfig;